/**
 * Editor constants and shared data
 */

export const GOOGLE_FONTS = [
  "Arial", "Helvetica", "Times New Roman", "Georgia", "Verdana", "Courier New",
  "Roboto", "Open Sans", "Lato", "Montserrat", "Oswald", "Raleway",
  "PT Sans", "Merriweather", "Nunito", "Playfair Display", "Poppins",
  "Ubuntu", "Bebas Neue", "Pacifico", "Dancing Script", "Quicksand"
];

export const FONT_WEIGHT_OPTIONS = [
  { value: 400, label: "Regular" },
  { value: 500, label: "Medium" },
  { value: 600, label: "Semi Bold" },
  { value: 700, label: "Bold" },
  { value: 800, label: "Extra Bold" },
  { value: 900, label: "Black" },
];

export const TEXT_ALIGN_OPTIONS = [
  { value: "left", label: "Left" },
  { value: "center", label: "Center" },
  { value: "right", label: "Right" },
];

export const DEFAULT_BANNER_STATE = {
  name: "",
  lottery_id: "",
  background_image: "",
  background_color: "#ffffff",
  use_transparent_background: false,
  banner_width: 800,
  banner_height: 400,
  position_x: 50,
  position_y: 50,
  scale: 1.0,
  number_gap: 2,
  // Result Text
  show_result_text: true,
  result_text_position_x: 50,
  result_text_position_y: 10,
  result_text_font: "Arial",
  result_text_color: "#FFFFFF",
  result_text_size: 18,
  result_text_font_weight: 700,
  result_text_shadow: true,
  result_text_shadow_color: "#000000",
  result_text_shadow_x: 2,
  result_text_shadow_y: 2,
  result_text_shadow_blur: 4,
  result_text_align: "left",
  result_text_custom_font_id: null,
  // Custom Text
  custom_text: "",
  show_custom_text: true,
  show_text: true,
  text_position_x: 50,
  text_position_y: 20,
  text_font: "Arial",
  text_color: "#FFFFFF",
  text_size: 20,
  text_font_weight: 700,
  text_shadow: true,
  text_shadow_color: "#000000",
  text_shadow_x: 2,
  text_shadow_y: 2,
  text_shadow_blur: 4,
  text_align: "left",
  text_custom_font_id: null,
  // Number settings
  number_set_id: null,
  use_number_images: true,
  number_text_font: "Arial",
  number_text_color: "#FFFFFF",
  number_text_size: 24,
  number_text_shadow: false,
  custom_number_set: null,
  custom_font_id: null,
  // Analytics
  destination_url: "",
};
